/* eslint-disable camelcase */
import React from "react";
// eslint-disable-next-line
import { cropr, gettext } from "../../adapter";
import DayPart from "./DayPart";
import moment from "moment";

const Day = ({ day, view, width }) => {
  var widthclass = "weather--day" + width;

  var forecasts = day.forecasts.map(function (forecast) {
    var key = day.date + "-" + forecast.hour;
    return <DayPart key={key} forecast={forecast} view={view} />;
  });

  var today = moment();
  //    var offset = today.getTimezoneOffset()*1000*60;
  var tomorrow = moment().add(1, "days");
  var date = new Date(day.date);
  var the_date = moment(day.date);

  if (today.isSame(the_date, "day")) {
    date = gettext("Today");
  } else if (tomorrow.isSame(the_date, "day")) {
    date = gettext("Tomorrow");
  } else {
    if (widthclass === "weather--day--24") {
      date = the_date.format("dd D MMM");
    } else {
      date = the_date.format("dddd D MMMM");
    }
  }

  var precision = cropr.l10n.unit_precipitation === "in" ? 2 : 1;
  var evaporation = (
    <div className="weather--eto">
      {gettext("ETo")}:{" "}
      <strong>
        {cropr.toLocaleFixed(
          cropr.l10n_utils.mm_to_l10n(day.predictedEvapotranspiration),
          precision
        )}{" "}
        {cropr.l10n.unit_precipitation_display}
      </strong>
    </div>
  );

  return (
    <>
      <div className="weather--dayheader">{date}</div>
      <ul className={widthclass}>{forecasts}</ul>
      {evaporation}
    </>
  );
};

export default Day;
